import React from "react";
import { ImageIcon } from "lucide-react";

export default function ImagePlaceholder({ label = "Bild-Platzhalter", ratio = "aspect-[4/3]", className = "", src, alt }) {
  if (src) {
    return (
      <div className={`overflow-hidden rounded-2xl ${ratio} ${className}`}>
        <img src={src} alt={alt || label} className="w-full h-full object-cover" loading="lazy" />
      </div>
    );
  }
  return (
    <div className={`image-placeholder rounded-2xl ${ratio} ${className}`} data-testid="image-placeholder">
      <div className="flex flex-col items-center gap-2 opacity-70">
        <ImageIcon className="w-6 h-6" />
        <span className="text-xs font-medium tracking-wide uppercase">{label}</span>
      </div>
    </div>
  );
}
